import CalendarTodayRoundedIcon from "@mui/icons-material/CalendarTodayRounded";
import { MetaDescriptorBase, MetaIcons } from "../../../../api/biClient.types.ts";
import FunctionIcon from "../../../../icons/FunctionIcon";
import HashIcon from "../../../../icons/HashIcon";
import SigmaIcon from "../../../../icons/SigmaIcon";

export const getIcon = (fieldBase: MetaDescriptorBase) => {
  switch (fieldBase.icon) {
    case MetaIcons.Hash:
      return <HashIcon />;
    case MetaIcons.Calendar:
      return <CalendarTodayRoundedIcon />;
    case MetaIcons.Sigma:
      return <SigmaIcon />;
    case MetaIcons.Function:
      return <FunctionIcon />;
    default:
      return <SigmaIcon />;
  }
};
